module.exports = __webpack_public_path__ + "static/media/change-currency-grey.18c2e8d7.svg";